export default function getGroupSelection(groupData, selectedGroup, user, groupType) {
  if (groupData && selectedGroup && groupData[groupType]) {
    if (groupData[groupType][selectedGroup]) {
      const active = groupData[groupType][selectedGroup]
      if (groupType === 'districts') {
        return {
          'School District': selectedGroup,
          School: '',
          Teacher: '',
          Class: '',
          Student: '',
        }
      } else if (groupType === 'schools') {
        return {
          'School District': active.district,
          School: selectedGroup,
          Teacher: '',
          Class: '',
          Student: '',
        }
      } else if (groupType === 'educators') {
        return {
          'School District': active.schoolDistrict,
          School: active.school,
          Teacher: selectedGroup,
          Class: '',
          Student: '',
        }
      } else if (groupType === 'classes') {
        return {
          'School District': active.district,
          School: active.school,
          Teacher: active.teacher,
          Class: selectedGroup,
          Student: '',
        }
      } else {
        return null        
      }
    } /*else if (user) {
      return {
        'School District': user.schoolDistrict,
        School: user.school ? user.school : '',
        Teacher: user.role === 'Teacher' ? user.id : '',
        Class: '',
        Student: '',
      }
    }*/ else {
      return null
    }
  } else {
    return null
  }
}
/*
export default function getGroupSelection(groupUAs, selectedGroupUA, user, groupType) {
  if (groupUAs && selectedGroupUA) {
    if (groupUAs[selectedGroupUA]) {
      const active = groupUAs[selectedGroupUA]
      const groupType = active.groupType
      if (groupType === 'School District') {
        return {
          'School District': selectedGroupUA,
          School: '',
          Teacher: '',
          Class: '',
          Student: '',
        }
      } else if (groupType === 'School') {
        return {
          'School District': active.district,
          School: selectedGroupUA,
          Teacher: '',
          Class: '',
          Student: '',
        }
      } else if (groupType === 'Teacher') {
        return {
          'School District': active.district,
          School: active.school,
          Teacher: selectedGroupUA,
          Class: '',
          Student: '',
        }
      } else if (groupType === 'Class') {
        return {
          'School District': active.district,
          School: active.school,
          Teacher: active.teacher,
          Class: selectedGroupUA,
          Student: '',
        }
      } else {
        console.log('getGroupSelection line: Individual student handling still needs to be built.')
        return null        
      }
    } /*else if (user) {
      return {
        'School District': user.schoolDistrict,
        School: user.school ? user.school : '',
        Teacher: user.role === 'Teacher' ? user.id : '',
        Class: '',
        Student: '',
      }
    }*//* else {
      return null
    }
  } else {
    return null
  }
}

*/


// WEBPACK FOOTER //
// ./src/helpers/assessment/getGroupSelection.js